<script setup lang="ts">
/**
 * A chapter's own heading.
 *
 * Only the heading: what a group *contains* is drawn by the canvas, which
 * renders each child through the same component it rendered this one with.
 * That recursion cannot live here without the block importing the thing that
 * renders it.
 *
 * A group used purely to organise the outline prints nothing at all, which is
 * what `showTitle` is for, and it takes no number either: a chapter nobody
 * sees cannot be chapter two.
 */
import { computed } from 'vue'

import type { GroupSection } from '@/domain/section'
import { useReportStore } from '@/stores/report'

const props = defineProps<{ section: GroupSection }>()

const report = useReportStore()

const number = computed(() => report.headingNumbers.get(props.section.id) ?? '')
</script>

<template>
  <h2 v-if="section.showTitle" :id="section.id" class="group__title">
    <span v-if="number" class="page-heading-number">{{ number }}</span>
    {{ section.title }}
  </h2>
</template>

<style scoped>
.group__title {
  margin-top: 0;
}
</style>
